import logo1 from "../../Assets/bluhrms_logo_dark.png";
import { Form } from "react-bootstrap";
import { GoEye, GoEyeClosed } from "react-icons/go";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UseFormValidations } from "../../FormValidation/UseFormValidations";
import "./Auth.css";
import { login } from "../../Config/ValidationSchema";
import { getList, notify, save } from "../../Config/SharedFunctions";
import { urls } from "../../Config/Consts";
import { updateLoggedInUser } from "../../Store/Action";
import { useDispatch } from "react-redux";
import { IoIosArrowRoundForward } from "react-icons/io";
import { returningValue } from "../../Config/SmallFunctions";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [type, setType] = useState("password");
  const submit = async () => {
    let res = await save(urls?.Auth?.login, data);

    if (res?.data?.status == true) {
      let resData = res?.data?.data;
      if (resData?.policyStatus == !true) navigate(`/policyacceptency/${resData?.user?.empId}`);
      else {
        sessionStorage.setItem("token", resData?.token);
        sessionStorage.setItem("startTime", Date?.now())
        sessionStorage.setItem("policyAcceptency", resData?.policyStatus);
        sessionStorage.setItem("user", JSON.stringify(resData?.user));
        dispatch(updateLoggedInUser(resData?.user?.empId));
        let res1 = await getList(urls.userAccess.getUserAccessLinks, { subscriptionId: resData?.user?.roleId });
        let links = res1?.filter((v) => v?.status == "Active")?.map((e) => e.linkName);
        sessionStorage.setItem("accessLinks", JSON.stringify(links));
        navigate("/v1/dashboard");
      }

    }
  };

  const forgotPassword = async () => {
    if (data?.email && data?.email != "") {
      let body = { serverName: window.location.hostname, email: data?.email };
      let res = await save(urls?.Auth?.SendForgotPasswordMail, body);
    } else {
      notify(false, "Please enter email");
    }
  };
  const { data, errors, handleSubmit, formChange } = UseFormValidations({
    validationSchema: login,
    submit: submit,
  });

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("user");
    if (loggedInUser) navigate("/v1/dashboard");
  }, []);

  return (
    <section className="keka-login-section">
      <div className="keka-login-row">
        {/* Left Panel - Illustration banner */}
        <div className="keka-left-panel"></div>

        {/* Right Panel - Login Card */}
        <div className="keka-right-panel">
          <div className="keka-login-card">
            {/* Logo */}
            <div className="keka-logo-container">
              <img src={logo1} alt="Logo" className="keka-logo" />
            </div>

            <h2>Welcome Back</h2>
            <p className="subtitle">Please login to your account</p>

            <Form id="login-form" onSubmit={handleSubmit}>
              {/* Email Field */}
              <div className="keka-input-group">
                <label className="keka-form-label" htmlFor="email">Email Address</label>
                <Form.Control
                  type="email"
                  required
                  id="email"
                  name="email"
                  className="keka-input-field"
                  placeholder="Enter email address"
                  onChange={formChange("")}
                  isInvalid={!!(errors && errors?.email)}
                />
                {errors && errors?.email && (
                  <Form.Control.Feedback type="invalid" style={{ display: 'block', textAlign: 'left', marginTop: '0.25rem' }}>
                    {errors?.email}
                  </Form.Control.Feedback>
                )}
              </div>

              {/* Password Field */}
              <div className="keka-input-group">
                <label className="keka-form-label" htmlFor="password">Password</label>
                <div className="keka-password-wrapper">
                  <Form.Control
                    type={type}
                    name="password"
                    required
                    id="password"
                    placeholder="Enter password"
                    className="keka-input-field"
                    onChange={formChange("")}
                    value={returningValue(data?.password, "")}
                    isInvalid={!!(errors && errors?.password)}
                  />
                  <button
                    type="button"
                    className="keka-eye-btn"
                    onClick={() => setType(type === "password" ? "text" : "password")}
                    id="togglePassword"
                    aria-label={type === "password" ? "Show password" : "Hide password"}
                  >
                    {type === "password" ? <GoEyeClosed /> : <GoEye />}
                  </button>
                </div>
                {errors && errors?.password && (
                  <Form.Control.Feedback type="invalid" style={{ display: 'block', textAlign: 'left', marginTop: '0.25rem' }}>
                    {errors?.password}
                  </Form.Control.Feedback>
                )}
              </div>

              {/* Forgot Password Link */}
              <div className="keka-forgot-password-container">
                <button type="button" className="keka-forgot-password" onClick={forgotPassword}>
                  Forgot Password?
                </button>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                onClick={handleSubmit}
                className="keka-btn-primary"
              >
                <span>Log in</span>
                <IoIosArrowRoundForward size={25} />
              </button>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
